import React from 'react';
import { useTranslation } from 'react-i18next';
import useQuotationActionsDialog from 'hooks/dialogs/useQuotationActionsDialog';
import PrimaryBtn from '../../../shared/Buttons/PrimaryButton';
import { PageTitle } from '../../../shared/Typography/PageTitle';
import { Box, styled, Typography } from '@mui/material';
import { QuotationsTable } from '../../../quotations/QuotationsTable';

export const TitleWrapper = styled(Box)(() => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: '20px',
}));

export const Quotations: React.FC = () => {
    const dialog = useQuotationActionsDialog();

    const { t } = useTranslation('quotations', {
        keyPrefix: 'QUOTATIONS',
    });

    const handleOpenCreateRequestModal = (): void =>
        dialog.showDialog(true, 'createNew', 'add', [], 'CREATE_NEW_TITLE');

    return (
        <>
            <TitleWrapper>
                <PageTitle>{t('TITLE')}</PageTitle>
                <PrimaryBtn onClick={handleOpenCreateRequestModal}>
                    {t('ADD_NEW')}
                </PrimaryBtn>
            </TitleWrapper>

            <Box>
                <Typography paragraph>{t('DESCRIPTION')}</Typography>
            </Box>

            <QuotationsTable />
        </>
    );
};
